export const arrayOf = (size: number): number[] =>
  Array.from(Array(size), (_, i) => i + 1);
